import { render, staticRenderFns } from "./VideoPlayerDefault.vue?vue&type=template&id=3e5302a3&scoped=true"
import script from "./VideoPlayerDefault.vue?vue&type=script&lang=js"
export * from "./VideoPlayerDefault.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerDefault.vue?vue&type=style&index=0&id=3e5302a3&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5302a3",
  null
  
)

export default component.exports